import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
  TextField,
} from "@mui/material";
import { CalendarToday } from "@mui/icons-material";
import moment from "dayjs";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.css";

const DateTimePicker = ({
  fieldValues = {},
  field = {},
  values = {},
  onChange = () => {},
  ...props
}) => {
  const [date, setDate] = useState(
    values[field.key] ? new Date(values[field.key]) : null
  );
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  const openPicker = () => {
    if (field.defaultToNowOnOpen){
        const now = new Date();
        setDate(now);
        onChange(field, now);
    }
    setIsPickerOpen(true);
  };

  const handleDateTimeChange = (selectedDate) => {
    if (selectedDate) {
      setDate(selectedDate);
      onChange(field, selectedDate);
    } else {
      setDate(null);
      onChange(field, "");
    }
  };

  const now = new Date();
  const timeIntervals = field.timeIntervals || 1;
  const minSelectableTime = field.startMinutes
  ? new Date(now.getTime() + field.startMinutes * 60000)
  : now;
  const isToday = date
  ? moment(date).isSame(moment(minSelectableTime), 'day')
  : true; // default to today if date is not selected

  const defaultMinTime = new Date();
  defaultMinTime.setHours(0, 0, 0, 0);

  const defaultMaxTime = new Date();
  defaultMaxTime.setHours(23, 59, 59, 999);

  return (
    <>
      <TextField
        type="text"
        required={(field.visible && field.required) || false}
        error={props.fieldErrors[field.key] ? true : false}
        key={field.key}
        id={`textfield_${field.key}`}
        size="medium"
        label={field.label}
        value={date ? moment(date).format("MM-DD-YYYY h:mm A") : ""}
        hidden={!field.visible}
        helperText={
          props.fieldErrors[field.key]
            ? props.fieldErrors[field.key]
            : undefined
        }
        variant="outlined"
        onKeyDown={props.validate?.bind(this, field)}
        disabled={field.disabled}
        className="mb-3"
        fullWidth
        onClick={openPicker}
        onFocus={(e) => {
          e.currentTarget.blur();
        }}
        slotProps={{ inputLabel: { shrink: true }, input: {
          endAdornment: (
            <InputAdornment position="end">
              <CalendarToday />
            </InputAdornment>
          ),
        } }}
      />

      <Dialog open={isPickerOpen} onClose={() => setIsPickerOpen(false)}>
        <DialogContent>
          <div className="custom-datepicker-wrapper">
            <ReactDatePicker
              selected={date}
              onChange={handleDateTimeChange}
              showTimeSelect
              timeFormat="h:mm aa"
              timeIntervals={timeIntervals}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              minDate={minSelectableTime}
              minTime={isToday ? minSelectableTime : defaultMinTime}
              maxTime={defaultMaxTime}
              inline
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              setDate(null);
              onChange(field, "");
              setIsPickerOpen(false);
            }}
          >
            Clear
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setIsPickerOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DateTimePicker;
